
<template>
  <Breadcrumbs main="Event" title="Upload" />
  <div class="container-fluid">
    <div
      v-if="
        this.is_event_permission === 'Y' && this.eventDetails.uploadable === 'Y'
      "
    >
      <div class="col-sm-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div
                class="col-xl-12"
                style="
                  text-align: left;
                  background-color: lightgray;
                  border-radius: 1rem;
                "
              >
                <b>&nbsp;</b><br />
                <b>{{ t("usageGuidelines") }}</b>
                <p class="small-text">
                  1. {{ t("guide1Prefix") }}
                  <span style="color: red; text-decoration: underline">{{ t("guide1Highlight") }}</span>
                  {{ t("guide1TailPrefix") }}<span style="color: red; text-decoration: underline">{{ t("guide1Safari") }}</span>{{ t("guide1TailSuffix") }}<br />
                  2. {{ t("guide2") }}<br />
                  3. {{ t("guide3Prefix") }}
                  {{ t("guide3Suffix") }}<u
                    ><a
                      :href="websiteUrl + '/running-img/running-export-lr-setting.jpg'"
                      target="_blank"
                      >{{ t("guide3Link") }}</a
                    ></u
                  ><br />
                  4. {{ t("guide4") }}<br />
                  5. {{ t("guide5") }}
                </p>

                <div class="row">
                  <div class="col-xl-9 col-sm-9">
                    <textarea
                      class="small-text"
                      rows="13"
                      v-model="this.eventDetails.post_caption"
                    >
                    </textarea>
                  </div>
                  <div
                    class="col-xl-3 col-sm-3 qr-code-container"
                    style="text-align: center"
                  >
                    <vue-qrcode
                      :value="this.qr_code"
                      :options="{
                        errorCorrectionLevel: 'high',
                        width: 180,
                        quality: 0.99,
                      }"
                    ></vue-qrcode
                    ><br />
                    <a
                      style="font-size: smaller"
                      target="_blank"
                      :href="
                        this.website_url + '/' + this.$route.params.q + '/qr'
                      "
                      ><u>{{ t("downloadQrCode") }}</u></a
                    >
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xl-4 col-sm-4" style="text-align: center">
                <p style="color: rgb(0, 0, 0)">
                  {{ t("uploadTotal") }}: {{ this.total }} (<a
                    target="_blank"
                    :href="'/upload-images/' + this.eventDetails.event_key"
                    ><u>{{ t("fileList") }}</u></a
                  >)
                </p>
              </div>
              <div class="col-xl-4 col-sm-4" style="text-align: center">
                <p style="color: rgb(255, 102, 0)">
                  {{ t("waitForTagging") }}: {{ this.processing }}
                </p>
              </div>
              <div class="col-xl-4 col-sm-4" style="text-align: center">
                <p style="color: green">{{ t("tagged") }}: {{ this.taged }}</p>
              </div>
            </div>
            <div
              class="card card-btn-upload"
              v-if="
                this.eventDetails.is_hybrid === 'Y' &&
                this.eventDetails.is_mhao_hybrid === 'N'
              "
            >
              <span
                >{{ t("hybridMessage") }}<br />{{ t("creditBalance") }}
                {{ this.credit_balance===0?'loading...':this.credit_balance }}</span
              >
              <a target="_blank" href="/credit-create"
                ><b><u>{{ t("addCredit") }}</u></b></a
              >
              <div class="row">
                <div class="col-sm-12">
                  <span style="color: red; font-size: small"
                    >{{ t("uploadBeforeSale") }} <u>{{ this.eventDetails.on_sale_start_txt }}</u> {{ t("maintainRights") }}</span
                  >
                </div>
            </div>
            </div>
            <div
              class="card card-btn-upload"
              v-if="this.eventDetails.is_enable_image_adjustment === 'Y'"
            >
              <hr />
              <div class="col-sm-12">
                <span>🌟 {{ t("autoAdjustTitle") }} 🌟: </span>&nbsp;&nbsp;
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    v-model="is_image_addjustment"
                    type="radio"
                    name="inlineRadioOptions"
                    id="inlineRadio1"
                    value="Y"
                  />
                  <label class="form-check-label" for="inlineRadio1">
                    {{ t("enable") }}
                  </label>
                </div>
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    v-model="is_image_addjustment"
                    type="radio"
                    name="inlineRadioOptions"
                    id="inlineRadio2"
                    value="N"
                  />
                  <label class="form-check-label" for="inlineRadio2">
                    {{ t("disable") }}
                  </label>
                </div>
              </div>
              <hr />
            </div>
          </div>
        </div>
      </div>

      <div class="card card-btn-upload">
        <div class="row" v-if="this.eventDetails.is_event_stage === 'Y'" style="padding-top: 10px;">
          <div class="col-sm-1 col-lg-1 col-xl-1"></div>
          <div class="col-sm-10 col-lg-10 col-xl-10">
            <div class="form-floating mb-3">
              <select 
                class="form-select"
                required
                id="floatingSelect"
                v-model="event_stages"
                aria-label="Floating label select example"
              >
                <option
                  v-for="(item, index) in this.eventDetails.stage"
                  :key="index"
                  :value="item.id"
                >
                  #{{ this.currentLanguage === "en" ? item.name_en : item.name }}
                </option>
              </select>
              <label for="floatingSelect"
                >{{ t("stageLabel") }}</label
              >
            </div>
          </div>
          <div class="col-sm-1 col-lg-1 col-xl-1"></div>
        </div>

        <div class="col-sm-12">
          <div
            class="d-flex flex-column justify-content-center align-items-center text-center"
            style="white-space: normal; word-break: break-word"
          >
            <div style="font-size: 14px; color: gray">
              {{ t("uploadImageToEvent") }}
            </div>
            <b
              style="
                white-space: normal;
                word-break: break-word;
                margin-top: 4px;
              "
            >
              {{ this.eventDetails.title }} ({{ this.user.display_name }})
            </b>
          </div>
          <div class="card-body btn-showcase">
            <label
              class="btn btn-primary btn-sm"
              :class="{ disabled: upload_store.isRunning }"
              for="selectBtn"
            >
              <vue-feather type="upload-cloud" size="13"></vue-feather> {{ t("chooseFileToUpload") }}
            </label>
            <button
              class="btn btn-success btn-sm"
              :disabled="upload_store.isRunning"
              @click.prevent="
                upload_store.uploadSelectedFiles(
                  this.eventDetails.event_key,
                  this.eventDetails.event_watermark_hori,
                  this.eventDetails.event_watermark_vertical,
                  this.user.user_id,
                  this.eventDetails.event_id,
                  this.eventDetails.server_upload_url_text,
                  this.eventDetails.server_upload_url_aws,
                  this.eventDetails.is_free_download,
                  this.eventDetails.is_add_watermark_for_free_download,
                  this.eventDetails.is_event_stage,
                  this.event_stages,
                  this.eventDetails.is_mhao,
                  this.eventDetails.is_hybrid,
                  this.eventDetails.is_mhao_hybrid,
                  this.credit_balance,
                  this.is_image_addjustment
                )
              "
              type="button"
              data-bs-toggle="tooltip"
              :title="t('uploadTitle')"
            >
              {{
                upload_store.failed_count > 0 ? t("retryUpload") : t("startUpload")
              }}
            </button>
            <button
              class="btn btn-info btn-sm"
              :disabled="upload_store.isRunning"
              type="button"
              data-bs-toggle="tooltip"
              :title="t('clearTitle')"
              @click.prevent="clear_upload"
            >
              <vue-feather type="refresh-cw" size="15"></vue-feather> {{ t("reset") }}
            </button>
            <div class="row">
              <div class="col-xl-4 col-sm-4">
                <b
                  >{{ t("uploadQueue") }} (<span style="color: cornflowerblue">{{
                    upload_store.selectedFiles.length -
                    upload_store.success_count
                  }}</span
                  >)
                </b>
              </div>
              <div class="col-xl-4 col-sm-4">
                <b
                  >{{ t("uploadSuccessful") }} (<a
                    target="_blank"
                    :href="'/upload-images/' + this.eventDetails.event_key"
                    ><span style="color: green">{{
                      upload_store.success_count
                    }}</span></a
                  >)
                </b>
              </div>
              <div class="col-xl-4 col-sm-4">
                <b
                  >{{ t("uploadFailed") }} (<span style="color: red">{{
                    upload_store.failed_count
                  }}</span
                  >)
                </b>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span
        v-show="uploadingFilesFailed.length"
        style="color: red; font-size: small"
      >
        {{ upload_store.errorMsg }}</span
      >
      <div style="height: 450px;">
      <div
        class="row"
        v-show="uploadingFilesFailed.length && !upload_store.isUploading"
      >
        <div class="col-sm-12">
          <div class="card">
            <div class="my-gallery card-body row gallery-with-description">
              <div
                class="col-xl-4 col-sm-4"
                v-for="(file, index) in uploadingFilesFailed"
                :key="index"
              >
                <span class="failed"
                  >{{ file.file.name }} [{{ t("fileFailed") }}]
                  <div class="progress-bar-wrapper"></div>
                </span>
              </div>
            </div>
            &nbsp;
          </div>
        </div>
      </div>
      <div class="row" v-show="uploadingFiles.length">
        <div class="col-sm-12">
          <div class="card">
            <div class="my-gallery card-body row gallery-with-description">
              <div
                class="col-xl-12 col-sm-12"
                v-for="(file, index) in uploadingFiles"
                :key="index"
              >
                <span class="uploading"
                  >{{ file.file.name }} [{{ t("fileUploading") }} {{ file.percentage }}%]
                  <div class="progress-bar-wrapper">
                    <div
                      class="progress-bar-fill"
                      :style="{ width: file.percentage + '%' }"
                    ></div>
                  </div>
                </span>
              </div>
            </div>
            &nbsp;
          </div>
        </div>
      </div>
      </div>
    </div>
    <div v-if="this.eventDetails.uploadable === 'N'">
      <div class="row">
              <div
                class="col-xl-12"
                style="
                  text-align: left;
                  background-color: lightgray;
                  border-radius: 1rem;
                "
              >
                <b>&nbsp;</b><br />
                <b>{{ t("usageGuidelines") }}</b>
                <p class="small-text">
                  1. {{ t("guide1Prefix") }} <span style="color: red; text-decoration: underline">{{ t("guide1Highlight") }}</span>
                  {{ t("guide1Tail") }}<br />
                  2. {{ t("guide2") }}<br />
                  3. {{ t("guide3Prefix") }} {{ t("guide3Suffix") }}<u
                    ><a
                      :href="websiteUrl + '/running-img/running-export-lr-setting.jpg'"
                      target="_blank"
                      >{{ t("guide3Link") }}</a
                    ></u
                  ><br />
                  4. {{ t("guide4") }}<br />
                  5. {{ t("guide5") }}
                </p>

                <div class="row">
                  <div class="col-xl-9 col-sm-9">
                    <textarea
                      class="small-text"
                      rows="13"
                      v-model="this.eventDetails.post_caption"
                    >
                    </textarea>
                  </div>
                  <div
                    class="col-xl-3 col-sm-3 qr-code-container"
                    style="text-align: center"
                  >
                    <vue-qrcode
                      :value="this.qr_code"
                      :options="{
                        errorCorrectionLevel: 'high',
                        width: 180,
                        quality: 0.99,
                      }"
                    ></vue-qrcode
                    ><br />
                    <a
                      style="font-size: smaller"
                      target="_blank"
                      :href="
                        this.website_url + '/' + this.$route.params.q + '/qr'
                      "
                      ><u>{{ t("downloadQrCode") }}</u></a
                    >
                  </div>
                </div>
              </div>
            </div>
            
      
    
      {{ t("uploadTotal") }}: {{ this.total }} (<a
        target="_blank"
        :href="'/upload-images/' + this.eventDetails.event_key"
        ><u>{{ t("fileList") }}</u></a
      >)

      <hr>
      <div class="d-flex justify-content-center" style="color: red">
        &nbsp;&nbsp;&nbsp;{{ t("uploadClosedMessage") }}
      </div>
    </div>
    <div v-if="this.is_event_permission === 'CHECKING'">
      <div class="d-flex justify-content-center">{{ t("authorizedChecking") }}</div>
    </div>
    <div v-if="this.is_event_permission === 'N'">
      <div class="d-flex justify-content-center">
        {{ t("pageNotAuthorized") }}
      </div>

      <div v-if="this.is_mhao !== 'Y' && this.loadding === 'N'">
        <div class="d-flex justify-content-center">{{ t("eventNotCorrect") }}</div>
      </div>
    </div>
  </div>

  <input
    id="selectBtn"
    type="file"
    multiple
    accept=".jpg,.jpeg"
    title="Upload file"
    @change="upload_store.onSelectFiles"
  />
</template>
  <script>
import { useUploadStore } from "./upload";
import axios from "axios";
import language from "@/components/header/language.vue";

  const LANGUAGE_TEXT = {
    en: {
      usageGuidelines: "System Usage Guidelines",
      guide1Prefix: "To increase upload speed, open multiple tabs",
      guide1Highlight: "using different browsers",
      guide1TailPrefix: "or modes, such as Google Chrome, Chrome Incognito, ",
      guide1Safari: "Safari (Upload limit only 2400 files)",
      guide1TailSuffix: ", Microsoft Edge, and Edge InPrivate, to bypass connection limits per browser.",
      guide2: "Upload only JPEG files (.jpg/.jpeg) and with a minimum dimension of approximately 3900 pixels on the longest side.",
      guide3Prefix: "Ensure your file is closed not export before uploading. If your file is larger, please export before uploading. Files exceeding 4.5 MB will disable the Fast Uploader",
      guide3Suffix: "Export setting: Quality: 70, Resolution: 70, Image size: 4300px (Long Edge), Exp.",
      guide3Link: "Lightroom export settings",
      guide4: "Upload approximately 1,000-2,000 photos at a time for faster upload.",
      guide5: "Make sure file names are unique. The system will skip files with duplicate names.",
      downloadQrCode: "Download Large QR Code",
      uploadTotal: "upload total",
      fileList: "file list",
      waitForTagging: "wait for tagging",
      tagged: "tagged",
      uploadClosedMessage: "Image upload is closed for this event. If you need to upload additional images, please contact the team leader or admin.",
      authorizedChecking: "authorized checking...",
      pageNotAuthorized: "this page is not authorized",
      eventNotCorrect: "event is not currect!",
      stageLabel: "# / Photo Locations / Activity / Stations",
      uploadImageToEvent: "upload image to event",
      chooseFileToUpload: "Choose file to upload",
      retryUpload: "Retry upload",
      startUpload: "Start upload",
      uploadTitle: "Upload",
      clearTitle: "Clear",
      reset: "Reset",
      uploadQueue: "upload queue",
      uploadSuccessful: "upload successful",
      uploadFailed: "upload failed",
      hybridMessage: "This event uses hybrid sales format with credit system",
      creditBalance: "Credit balance:",
      addCredit: "Add Credit",
      uploadBeforeSale: "Please upload images before sales start on",
      maintainRights: "to maintain selling rights in hybrid format",
      autoAdjustTitle: "Enable Auto Image Adjustment",
      enable: "Enable",
      disable: "Disable",
      fileFailed: "failed",
      fileUploading: "uploading",
      errorOccurred: "Error occurred. Please contact system administrator or try again.",
      getCreditError: "[getCredit] Error occurred!",
      authFailed: "Authentication Failed! ",
      authFailedContact: "Authentication Failed! Please contact administrator.",
      eventDetailError: "[EventDetail] Error occurred!",
      taggedError: "[Taged] Error occurred!",
    },
    th: {
      usageGuidelines: "คำแนะนำการใช้งานระบบ",
      guide1Prefix: "ถ้าต้องการเปิดหลายแท็บ เพื่อเพิ่มความเร็ว",
      guide1Highlight: "ต้องเปิดในเบราว์เซอร์ต่างกัน",
      guide1TailPrefix: "เช่น Google Chrome, Chrome Incognito, ",
      guide1Safari: "Safari(Upload ได้ครั้งละไม่เกิน 2400 ใบ)",
      guide1TailSuffix: ", Microsoft Edge, และ Edge InPrivate เพื่อหลีกเลี่ยงข้อจำกัดการเชื่อมต่อของแต่ละเบราว์เซอร์",
      guide2: "Upload ไฟล์ JPEG (.jpg/.jpeg) เท่านั้น และต้องมีขนาดด้านยาวอย่างน้อยประมาณ 3900 พิกเซล",
      guide3Prefix: "ตรวจสอบให้แน่ใจว่าไฟล์ของคุณปิดอยู่และไม่ได้ export ก่อนอัปโหลด หากไฟล์มีขนาดใหญ่ กรุณา export ก่อนอัปโหลด ไฟล์ที่เกิน 4.5 MB จะปิด Fast Uploader",
      guide3Suffix: "ตั้งค่าการ Export: Quality: 70, Resolution: 70, Image size: 4300px (Long Edge), Exp.",
      guide3Link: "ตัวอย่างการตั้งค่า Lightroom",
      guide4: "อัปโหลดภาพครั้งละประมาณ 1,000-2,000 ภาพ เพื่อความรวดเร็ว",
      guide5: "ควรตั้งชื่อไฟล์ไม่ให้ซ้ำกัน ระบบจะข้ามการอัปโหลดไฟล์ชื่อซ้ำ",
      downloadQrCode: "ดาวน์โหลด QR Code ขนาดใหญ่",
      uploadTotal: "อัปโหลดทั้งหมด",
      fileList: "รายการไฟล์",
      waitForTagging: "รอการติดแท็ก",
      tagged: "ติดแท็กแล้ว",
      uploadClosedMessage: "กิจกรรมนี้ปิดการอัปโหลดรูปภาพ หากต้องการอัปโหลดรูปภาพเพิ่มเติม กรุณาติดต่อหัวหน้าทีม หรือแอดมิน",
      authorizedChecking: "กำลังตรวจสอบสิทธิ์...",
      pageNotAuthorized: "หน้านี้ไม่ได้รับอนุญาต",
      eventNotCorrect: "กิจกรรมไม่ถูกต้อง!",
      stageLabel: "# / จุดถ่ายภาพ / กิจกรรม / สถานี",
      uploadImageToEvent: "อัปโหลดรูปภาพเข้ากิจกรรม",
      chooseFileToUpload: "เลือกไฟล์เพื่ออัปโหลด",
      retryUpload: "อัปโหลดใหม่",
      startUpload: "เริ่มอัปโหลด",
      uploadTitle: "อัปโหลด",
      clearTitle: "ล้าง",
      reset: "รีเซ็ต",
      uploadQueue: "คิวอัปโหลด",
      uploadSuccessful: "อัปโหลดสำเร็จ",
      uploadFailed: "อัปโหลดล้มเหลว",
      hybridMessage: "กิจกรรมนี้เป็นรูปแบบการขายแบบไฮบริด มีการใช้งานระบบเครดิต",
      creditBalance: "เครดิตคงเหลือ:",
      addCredit: "เติมเครดิต",
      uploadBeforeSale: "*กรุณาอัปโหลดภาพให้เรียบร้อยก่อนเปิดขาย",
      maintainRights: "เพื่อรักษาสิทธิ์ในการขายภาพในรูปแบบไฮบริด",
      autoAdjustTitle: "เปิดใช้งานระบบแต่งภาพอัตโนมัติ",
      enable: "เปิดใช้งาน",
      disable: "ปิดใช้งาน",
      fileFailed: "ล้มเหลว",
      fileUploading: "กำลังอัปโหลด",
      errorOccurred: "พบข้อผิดพลาดกรุณาติดต่อผู้ดูแลระบบ หรือลองใหม่อีกครั้ง",
      getCreditError: "[getCredit] พบข้อผิดพลาด!",
      authFailed: "การตรวจสอบสิทธิ์ล้มเหลว! ",
      authFailedContact: "การตรวจสอบสิทธิ์ล้มเหลว! กรุณาติดต่อผู้ดูแลระบบ",
      eventDetailError: "[EventDetail] พบข้อผิดพลาด!",
      taggedError: "[Taged] พบข้อผิดพลาด!",
    },
  };

export default {
  components: { language },
  setup() {
    const upload_store = useUploadStore();
    return { upload_store };
  },
  data() {
    return {
      websiteUrl: process.env.VUE_APP_WEBSITE_URL,
      eventDetails: {},
      selectedFiles: [],
      processing: 0,
      taged: 0,
      total: 0,
      loading: true,
      user: {},
      qr_code: process.env.VUE_APP_WEBSITE_URL + "/" + this.$route.params.q,
      is_event_permission: "CHECKING",
      event_stages: 0,
      credit_balance: 0,
      website_url: process.env.VUE_APP_WEBSITE_URL,
      is_image_addjustment: "N",
    };
  },
  computed: {
    currentLanguage() {
      return (process.env.VUE_APP_LANGUAGE || "").toLowerCase() === "en"
        ? "en"
        : "th";
    },
    uploadingFiles() {
      return this.upload_store.selectedFiles.filter(
        (file) => file.status === "uploading"
      );
    },
    uploadingFilesFailed() {
      return this.upload_store.selectedFiles.filter(
        (file) => file.status === "failed"
      );
    },
  },
  async mounted() {
    try {
      this.user = JSON.parse(localStorage.getItem("user"));
      let _is_event_permission = await this.event_permission();
      if (_is_event_permission === "Y") {
        let eventDetail = await this.getEventDetail(this.$route.params.q);
        await this.getTaged(eventDetail.event_id, this.user.user_id);
        if (
          this.eventDetails.is_hybrid === "Y" &&
          this.eventDetails.is_mhao_hybrid === "N"
        ) {
          await this.getCredit();
        }
      }
    } catch (error) {
      alert(this.t("errorOccurred"), error);
      location.reload();
    }
  },
  methods: {
    t(key) {
      return LANGUAGE_TEXT[this.currentLanguage][key] || LANGUAGE_TEXT.en[key] || key;
    },
    async getCredit(event_id, photographer_id) {
      const data = {
        event_id: event_id,
        photographer_id: photographer_id,
      };
      const headers = {
        Authorization: "Bearer " + localStorage.getItem("jwt"),
      };
      const res = await axios.post("/v1/utils/credit-balance", data, {
        headers,
      });
      if (res.data.status === "success") {
        this.credit_balance = res.data.body.credit_balance;
      } else {
        alert(this.t("getCreditError"));
      }
    },
    async clear_upload() {
      location.reload();
    },
    async event_permission() {
      try {
        let data = {
          event_key: this.$route.params.q,
        };
        const headers = {
          Authorization: "Bearer " + localStorage.getItem("jwt"),
        };
        const response = await axios.post("v1/order/event-permission", data, {
          headers,
        });
        if (response.data.status === "success") {
          this.is_event_permission = response.data.body.event_permission;
          return response.data.body.event_permission;
        } else {
          alert(this.t("authFailed"));
          return "N";
        }
      } catch (error) {
        alert(this.t("authFailedContact"));
        return "N";
      }
    },

    async getEventDetail(event_key) {
      const res = await axios.get("/v1/events/" + event_key);
      if (res.data.status === "success") {
        this.eventDetails = res.data;
        this.eventPackage = res.data.package;
        return res.data;
      } else {
        alert(this.t("eventDetailError"));
        this.$router.push({ path: "/" });
      }
    },
    async getTaged(event_id, photographer_id) {
      const data = {
        event_id: event_id,
        photographer_id: photographer_id,
      };
      const res = await axios.post("/v1/events/taged", data);
      if (res.data.status === "success") {
        this.processing = res.data.processing;
        this.taged = res.data.taged;
        this.total = res.data.total;
      } else {
        alert(this.t("taggedError"));
        this.$router.push({ path: "/" });
      }
    },
    cancel() {
      this.$router.push({ path: "/" });
    },
  },
};
</script>
<style scoped lang="scss">
#selectBtn {
  display: none;
}
.progress-bar-wrapper {
  height: 3px;
  background-color: #f0f0f0;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 2px;
}

.progress-bar-fill {
  height: 100%;
  background-color: #1890ff; /* สีแบบ ant.design */
  transition: width 0.1s ease;
}
.small-text {
  font-size: 13px;
  line-height: 1.2;
}
.card-btn-upload {
  text-align: center;
}
.card-file-list {
  text-align: center;
}

.upload-item {
  border: 1px solid rgb(197, 197, 197);
  border-radius: 0.5rem;
  float: left;
  padding: 1px;
  text-align: center;
}

.drop-container:hover {
  background: #979696ad;
}
.upload-item:hover {
  background: #e0e0e0ad;
  cursor: pointer;
  border: 1px dashed rgba(124, 2, 2, 0.616);
}

.buttons {
  display: flex;
  gap: 1rem;

  &.centered {
    justify-content: center;
  }
}

.button {
  cursor: pointer;

  color: white;
  background: #809af0;
  text-decoration: none;

  width: fit-content;
  padding: 0.5rem 1rem;
  border-radius: 2px;

  &:hover {
    background: #3f6cff;
  }

  &.disabled {
    cursor: default;
    background: lightgray;
    pointer-events: none;
  }
}

.button-danger {
  background: #f08080;

  &:hover {
    background: #f65959;
  }
}

.button-upload {
  background: #00d591;

  &:hover {
    background: #02b97f;
  }
}

.failed {
  color: red;
  font-size: x-small;
}

.success {
  color: green;
}

.uploading {
  color: #000000;
  font-size: x-small;
}

.failed-border {
  border-color: red;
}

textarea {
  width: 100%;
  background-color: #ffffffea;
  border-radius: 0.7rem;
}
.textwrapper {
  border: 1px solid #999999;
  margin: 5px 0;
  padding: 3px;
}
</style>